import Select from 'domains/core/components/Select';
import { VoiceCallFallback } from 'pages/ContentVoiceBuilderPage/types';
import { setRepeat } from 'pages/ContentVoiceBuilderPage/voiceCallActions';

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    isContentLoading: boolean;
    repeatValue: VoiceCallFallback['repeat'];
};

const RepeatSelect = ({ dispatchVoiceContentAction, isContentLoading, repeatValue }: Props) => (
    <Select
        disabled={isContentLoading}
        label="Repeat"
        menuItemStyles={{ textTransform: 'none' }}
        onChange={(e: any) => dispatchVoiceContentAction(setRepeat(e.target.value))}
        sx={{ width: '125px' }}
        type="string"
        value={repeatValue}
        values={[
            { label: '1 time', value: 1 },
            { label: '2 times', value: 2 },
        ]}
    />
);

export default RepeatSelect;
